module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/download_text.c8545.png";